import { Box, IconButton } from "@mui/material";
import { Modal, ModalBody } from "reactstrap";
import { APP_COLOR } from "../../theme";
import { messageModalStyles } from "./styles";
import CloseIcon from "@mui/icons-material/Close";
import MusicNoteIcon from "@mui/icons-material/MusicNote";
import { ModalButton } from "../../pages/MyTracks/styles";
import LoopIcon from "@mui/icons-material/Loop";

const ConfirmationMessageModal: React.FC<{
  message: string;
  isMessageModalOpen: boolean;
  toggle: () => void
}> = ({ message, isMessageModalOpen, toggle }) => {

  return (
    <Modal
      isOpen={isMessageModalOpen}
      toggle={toggle}
      centered
      keyboard={false}
    >
      <ModalBody style={messageModalStyles.postMessageModal}>
        <IconButton
          onClick={toggle}
          style={messageModalStyles.postMessageModalIcon}
        >
          <CloseIcon style={{ color: APP_COLOR }} />
        </IconButton>
        <Box sx={{ marginBottom: 4,color:'white' }}>
          <MusicNoteIcon style={{ fontSize: 55 }} />
          <LoopIcon style={{ fontSize: 50, marginLeft: -10 }} />
        </Box>
        <Box style={{ fontSize: 20, marginBottom: 10, textAlign: "center" ,color:"white" }}>
          {message}
        </Box>
        <ModalButton
          size="small"
          variant="contained"
          disableFocusRipple
          onClick={toggle}
        >
          Dismiss
        </ModalButton>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationMessageModal;
